var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center",class:_vm.c_noInfo ? 'text-danger':null},[(_vm.c_noInfo)?_c('span',{staticClass:"material-icons-round mr-50"},[_vm._v("warning")]):_vm._e(),_vm._v(" "+_vm._s(_vm.row.Plate)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }